import { Planner }   from "../../planner_base";
import { deepmerge } from 'utilities/merge';
export class PopperBase extends Planner {
  isShow: boolean = false;
  defaultOptions = {
    placement: 'auto',
    modifiers: {
      preventOverflow: {
        boundariesElement: 'window'
      },
      offset: {
        enabled: true,
        offset: '30px'
      }
    }
  }
  getPopperOptions(o = {}){
    return deepmerge(this.defaultOptions, o);
  }
}
